export enum ScanSessionsOrderBy {
	User = 'User',
	ScanType = 'ScanType',
	UploadTime = 'UploadTime',
}
